import * as yup from 'yup';

import { EMAIL_REGEX, isValidPhoneNumber, validateName } from '@aqx-core/common/validators';

import { i18n } from '../i18n';

interface ICreateSignUpDemoSchemaParams {
  isCentroidDemo: boolean;
}

export const createSignUpDemoSchema = ({ isCentroidDemo }: ICreateSignUpDemoSchemaParams) =>
  yup.object().shape({
    name: isCentroidDemo
      ? yup.string().default('')
      : yup
          .string()
          .required(() => i18n.t('Name is required.'))
          .test(
            'is-valid-name',
            () => i18n.t('Please enter a valid name.'),
            (value) => !!value && validateName(value)
          ),
    firstName: isCentroidDemo
      ? yup
          .string()
          .required(() => i18n.t('First name is required.'))
          .test(
            'is-valid-name',
            () => i18n.t('Please enter a valid name.'),
            (value) => !!value && validateName(value)
          )
      : yup.string().default(''),
    lastName: isCentroidDemo
      ? yup
          .string()
          .required(() => i18n.t('Last name is required.'))
          .test(
            'is-valid-name',
            () => i18n.t('Please enter a valid name.'),
            (value) => !!value && validateName(value)
          )
      : yup.string().default(''),
    email: yup
      .string()
      .required(() => i18n.t('Email is required.'))
      .matches(EMAIL_REGEX, () => i18n.t('Please enter a valid email.')),
    dialCode: yup.string().required(() => i18n.t('Dial code is required.')),
    localPhoneNumber: yup
      .string()
      .required(() => i18n.t('Phone number is required.'))
      .test(
        'is-valid-phone',
        () => i18n.t('Please enter a valid phone number.'),
        function (value) {
          const { dialCode } = this.parent;
          if (!dialCode || !value) {
            return false;
          }
          return isValidPhoneNumber(dialCode, value);
        }
      ),
    depositAmount: yup.number().required(() => i18n.t('Deposit is required.')),
    agree: yup
      .boolean()
      .required(() => i18n.t('Please review and accept the Terms and Conditions.'))
      .oneOf([true], () => i18n.t('Please review and accept the Terms and Conditions.'))
  });
